import { TAssets, TContentHubProductModelDetailHeroSectionFields } from '../types/productModelDetailHeroSection.types';
import { THeroSectionCarouselProps } from '../types/heroSectionCarousel.types';

export class HeroSectionCarouselModel {
  private readonly fields?: TContentHubProductModelDetailHeroSectionFields;

  constructor(props: THeroSectionCarouselProps) {
    this.fields = props?.fields || null;
  }

  get slides(): Array<TAssets> {
    return this.fields?.apiData?.assets || [];
  }
}
